<template>
  <div class="add-c-type-date">
    <div class="c-panel-tabView-title">日期类型</div>
    <div>
      <el-radio v-model="radio" label="1" disabled>单日期：年-月-日</el-radio>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio:"1"
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-type-date.vue